import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]

import { useModals } from "@/stores";
import { storeToRefs } from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  setup(__props) {

const { confirmModalData } = storeToRefs(useModals());

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(confirmModalData).isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(confirmModalData).isOpen) = $event)),
    class: "confirm-dialog",
    style: {"max-width":"460px"},
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: _normalizeClass(["confirm-dialog-window", { 'is-native': _unref(confirmModalData).isNative }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_unref(confirmModalData).title)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    textContent: _toDisplayString(_unref(confirmModalData).title),
                    class: "text-subtitle-1 mt-2"
                  }, null, 8, _hoisted_1))
                : _createCommentVNode("", true),
              (_unref(confirmModalData).text)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    textContent: _toDisplayString(_unref(confirmModalData).text),
                    class: "text-body-2 mt-2"
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "action-btn",
                size: "large",
                variant: _unref(confirmModalData).isNative ? 'text' : 'flat',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(confirmModalData).reject?.()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("common.cancel")), 1)
                ]),
                _: 1
              }, 8, ["variant"]),
              _createVNode(_component_v_btn, {
                class: "action-btn",
                size: "large",
                color: _unref(confirmModalData).isNative ? undefined : 'primary',
                variant: _unref(confirmModalData).isNative ? 'text' : 'flat',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(confirmModalData).confirm?.()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("common.confirm")), 1)
                ]),
                _: 1
              }, 8, ["color", "variant"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})